<template>
  <div class="flex gap-4" data-testid="page-category-product-list">
    <div>
      <img :src="productCategory?.imageUrl ?? ''" class="h-20 w-20" />
    </div>
    <div class="flex flex-col gap-4">
      <h2 class="txt-headline-m">{{ t('FestivalShop.products.orderCategory', { name: productCategory?.name }) }}</h2>
      <p>{{ productCategory.description }}</p>
    </div>
  </div>
  <CircleSpinner v-if="props.productsLoading" />
  <div v-else>
    <div class="flex shrink flex-wrap gap-4 pt-10">
      <ProductCard v-for="p in props.products" :key="p.id" :product="p" />
    </div>
    <div v-if="showPagination" class="max-w-[985px] pt-10">
      <PaginationControl
        :show-all-option="false"
        :show-per-page-options="false"
        :total="props.pageInfo?.totalCount ?? 0"
        :per-page="props.perPage"
        :current-page="props.currentPage"
        :position="'bottom'"
        @update:current-page="emit('update:currentPage', $event)"
        @update:per-page="emit('update:perPage', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { CircleSpinner, PaginationControl } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import ProductCard from '@/components/FestivalShop/ProductCategories/ProductCard.vue'
import type { FestivalShopProductsQuery, ProductCategory } from '@/gql/myomr'

const props = defineProps<{
  eventLoading: boolean
  eventSlug: string
  kioskId: string
  pageInfo: FestivalShopProductsQuery['festivalShopProducts']['pageInfo'] | undefined
  productCategoryId: string
  productCategory: ProductCategory
  products: FestivalShopProductsQuery['festivalShopProducts']['nodes']
  productsLoading: boolean
  currentPage: number
  perPage: number | 'all'
}>()

const { t } = useI18n()

const emit = defineEmits<{
  (e: 'update:currentPage', value: number): void
  (e: 'update:perPage', value: number | 'all'): void
}>()

const showPagination = computed(() => {
  const total = props.pageInfo?.totalCount ?? 0
  if (total === 0) return false
  if (props.perPage === 'all') return true
  return total > props.perPage
})
</script>
